module.exports = __webpack_public_path__ + "static/media/PinRiver.19118af1.svg";